import { render } from "./PromoPage.vue?vue&type=template&id=f0a7a18a&scoped=true"
import script from "./PromoPage.vue?vue&type=script&lang=js"
export * from "./PromoPage.vue?vue&type=script&lang=js"

import "./PromoPage.vue?vue&type=style&index=0&id=f0a7a18a&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a7a18a"]])

export default __exports__